import React, { useEffect, useState } from 'react';
import 'bootstrap-select';
import "styles/global.css"
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import LoadingSpinner from 'component/LoadingSpinner';
import TransactionService from 'service/TransactionService';
import DateRangeFilterDropdown from 'component/DateRangeFilterDropdown';
import CustomDropdown from 'component/CustomDropdown';
import { PageSizeOption } from 'domain/constant/PageSizeOption';

const Transaction: React.FC = () => {

  const { profile } = useSelector((state: any) => state.auth);
  const [data, setData] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingExportCsv, setLoadingExportCsv] = useState(false);
  const [timeRange, setTimeRange] = useState<{ startDate: string | null, endDate: string | null }>({ startDate: null, endDate: null });

  const transactionService = TransactionService()

  const fetchData = async () => {
    const token = profile?.data.token;
    if (!token) {
      window.alert('Token tidak ditemukan. Silakan login kembali.');
      return;
    }

    setLoading(true);
    try {
      const res = await transactionService.transactionList(
        token, searchTerm, currentPage, pageSize,
        timeRange.startDate != null && timeRange.startDate != "" ? timeRange.startDate : null,
        timeRange.endDate != null && timeRange.endDate != "" ? timeRange.endDate : null
      );
      console.log(res)
      setData(res.data ?? []);
      setTotalPages(res.pagination?.totalPage ?? 0);
      setTotalRecords(res.pagination?.totalRecords ?? 0)
    } catch (err: any) {
      console.error(err);
      const errorMessage = err.response?.data?.message || err.message || 'Terjadi kesalahan saat mengambil data transaksi';
      window.alert(`Error: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, pageSize, searchTerm]);

  const handleSearchClick = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setCurrentPage(1);
    fetchData();
  };

  const handleExportToCsv = async () => {
    const token = profile?.data.token;
    if (!token) {
      window.alert('Token tidak ditemukan. Silakan login kembali.');
      return;
    }

    setLoadingExportCsv(true);
    try {
      const response = await transactionService.transactionExportToCsv(
        token,
        searchTerm,
        timeRange.startDate,
        timeRange.endDate
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      const contentDisposition = response.headers["content-disposition"];
      const fileNameMatch = contentDisposition?.match(/filename="?([^"]+)"?/);

      if (!fileNameMatch || !fileNameMatch[1]) {
        throw new Error("Filename not found in Content-Disposition header");
      }

      const fileName = decodeURIComponent(fileNameMatch[1]);

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      window.alert('File CSV berhasil di-download');
      setLoadingExportCsv(false);
    } catch (error: any) {
      console.error("Error downloading CSV:", error);
      const errorMessage = error.response?.data?.message || error.message || 'Terjadi kesalahan saat download CSV';
      window.alert(`Error download CSV: ${errorMessage}`);
      setLoadingExportCsv(false);
    }
  };

  const handleDelete = async (id: string, transaction: string) => {
    const token = profile?.data.token;
    if (!token) {
      window.alert('Token tidak ditemukan. Silakan login kembali.');
      return;
    }

    const confirmDelete = window.confirm(
      `Apakah Anda yakin ingin menghapus Transaction "${transaction}"?`
    );
    if (!confirmDelete) return;

    try {
      await transactionService.transactionDelete(token, id);
      window.alert(`Transaction "${transaction}" berhasil dihapus`);
      fetchData();
    } catch (err: any) {
      console.error(err);
      const errorMessage = err.response?.data?.message || err.message || 'Terjadi kesalahan saat menghapus transaksi';
      window.alert(`Error: ${errorMessage}`);
    }
  };

  return (
    // <div className="page-wrapper h-100">
    //   <div className="row">
    //     <div className="col-12">
    //       <div className="d-flex">
    //         <h5 style={{flex:1}}>Transactions</h5>
    //         <div>
    //           <p>TransMore Transactions</p>
    //         </div>
    //       </div>
    //     </div>
    //     <div className="col-12">
    //       <div className="w-100" style={{background:'white'}}>
    //         <div className="row">
    //           <div className="col-sm-6">

    //           </div>
    //         </div>
    //       </div>
    //     </div>

    //   </div>
    // </div >

    <div className="page-wrapper">
      <div className="row">
        <div className="col-12">
          <div className="d-flex">
            <h5 style={{ flex: 1 }}>Transactions</h5>
            <div>
              <p>TransMore Transactions</p>
            </div>
          </div>
        </div>
        <div className="col-12">

          <div className="p-4" style={{ background: 'white' }}>
            <div className="mb-3 d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3">

              <form className="d-flex flex-column flex-sm-row" onSubmit={handleSearchClick}>
                <input
                  type="text"
                  className="form-control form-control-compact me-2 mb-2 mb-sm-0"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ minWidth: 120 }}
                />
                <button type="submit" className="px-4 btn btn-primary">
                  <i className="fa-solid fa-search"></i>
                </button>
              </form>

              <div className="d-flex flex-column flex-sm-row gap-2 align-items-start align-items-sm-center">
                <div className="me-2">

                  <DateRangeFilterDropdown
                    align="right"
                    onChange={(v) => {
                      setTimeRange({ startDate: v.startDate, endDate: v.endDate })
                    }} />
                </div>
                {/* <>
                    <button className="btn btn-outline-primary me-2">
                      Import From CSV
                    </button>
                  </> */}
                <button className="btn btn-outline-primary d-flex justify-content-center align-items-center" onClick={handleExportToCsv} disabled={loadingExportCsv}>
                  {loadingExportCsv && (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Export To CSV
                </button>
                {/* <>
                    <Link to="/Transaction/0" className='float-end text-decoration-none tm-text-primary'>
                      <button className="btn btn-primary">
                        <span className="me-2">Add</span>
                        <i className="fa-solid fa-plus"></i>
                      </button>
                    </Link>
                  </> */}
              </div>
            </div>

            <table className="table table-condensed table-hover">
              <thead className="table-primary">
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Full Name</th>
                  <th>Type</th>
                  <th>Amount</th>
                  <th>Remarks</th>
                  <th>Created At</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {
                  !loading ?
                    data.length > 0 ? (
                      data.map((item) => (
                        <tr key={item.id}>
                          <td>{item.id}</td>
                          <td>{item.transactionName}</td>
                          <td>{item.userFullName}</td>
                          <td>{item.type}</td>
                          <td>{item.amount}</td>
                          <td>{item.remarks}</td>
                          <td>{item.createdAt}</td>
                          <td>
                            <div className="d-flex">
                              <Link to={'/transaction/' + item.id}>
                                <button className="border-0 btn btn-outline-info btn-small-compact">
                                  <i className="fa-solid fa-eye"></i>
                                </button>
                              </Link>
                              <button
                                className="border-0 btn btn-outline-danger btn-small-compact ms-2"
                                onClick={() =>
                                  handleDelete(item.id, item.transactionName)
                                }>
                                <i className="fa-solid fa-trash"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={9} className="text-center">
                          Tidak ada data
                        </td>
                      </tr>
                    )
                    :
                    <tr>
                      <td colSpan={9} className="text-center">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </td>
                    </tr>
                }
              </tbody>
            </table>
            <div className="mt-3 d-flex justify-content-end align-items-center">
              <div className="d-flex align-items-center">
                <div className="me-4 d-flex align-items-center">
                  <label className="me-2">Rows per page:</label>
                  <CustomDropdown
                    value={pageSize}
                    options={PageSizeOption.options}
                    onChange={(opt) => {
                      setPageSize(Number(opt.id));
                      setCurrentPage(1);
                    }}
                    align="top"
                  />
                </div>
                <span className="me-3">
                  {`${(currentPage - 1) * pageSize + 1}–${Math.min(currentPage * pageSize, totalRecords)} of ${totalRecords}`}
                </span>

                <nav>
                  <ul className="mb-0 pagination">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(1)} style={{ border: 0 }}>
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)} style={{ border: 0 }}>
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>

                    <li className="page-item disabled">
                      <span className="page-link" style={{ border: 0 }}>{currentPage}</span>
                    </li>

                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)} style={{ border: 0 }}>
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(totalPages)} style={{ border: 0 }}>
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Transaction;
